import { PropsWithChildren } from "react";

export const FooterTitle = ({ children }: PropsWithChildren) => (
    <div className="text-2xl mb-2 whitespace-nowrap">{children}</div>
);
